import { Form } from "react-bootstrap";
import AddressAutocomplete from "../shared/fields/AddressAutocomplete";
import "../../styles/orderConfirmationModal.css";

export default function AudiologistDeliveryFields({
  delivery = {},
  errors = {},
  onChange,
  onPlaceSelect,
  title = "Delivery",
  showEmail = true,
  emailName = "email",
  emailPlaceholder = "Enter email address",
}) {
  const fieldClass = (name) =>
    `cmn_input${errors[name] ? " border border-danger" : ""}`;

  return (
    <div className="order-confirmation__delivery">
      {title ? (
        <h6 className="order-confirmation__section-title">{title}</h6>
      ) : null}

      <div className="order-confirmation__delivery-row order-confirmation__delivery-row--2">
        <Form.Control
          className={fieldClass("firstName")}
          name="firstName"
          value={delivery.firstName}
          onChange={onChange}
          placeholder="First name"
        />
        <Form.Control
          className={fieldClass("lastName")}
          name="lastName"
          value={delivery.lastName}
          onChange={onChange}
          placeholder="Last name"
        />
      </div>

      <AddressAutocomplete
        label=""
        name="address1"
        value={delivery.address1}
        onChange={onChange}
        onPlaceSelect={onPlaceSelect}
        placeholder="Address"
        error={Boolean(errors.address1)}
        className="order-confirmation__address-autocomplete mb-0"
      />

      <Form.Control
        className="cmn_input"
        name="address2"
        value={delivery.address2}
        onChange={onChange}
        placeholder="Apartment, suite, etc. (optional)"
      />

      <div className="order-confirmation__delivery-row order-confirmation__delivery-row--city-state-zip">
        <Form.Control
          className={fieldClass("city")}
          name="city"
          value={delivery.city}
          onChange={onChange}
          placeholder="City"
        />
        <Form.Control
          className={fieldClass("state")}
          name="state"
          value={delivery.state}
          onChange={onChange}
          placeholder="State"
        />
        <Form.Control
          className={fieldClass("zip")}
          name="zip"
          value={delivery.zip}
          onChange={onChange}
          placeholder="Postal code"
        />
      </div>

      <div
        className={
          showEmail
            ? "order-confirmation__delivery-row order-confirmation__delivery-row--2"
            : "order-confirmation__delivery-row"
        }
      >
        <Form.Control
          className={fieldClass("phone")}
          name="phone"
          value={delivery.phone}
          onChange={onChange}
          placeholder="Enter phone number"
        />
        {showEmail ? (
          <Form.Control
            className={fieldClass(emailName)}
            type="email"
            name={emailName}
            value={delivery[emailName] || ""}
            onChange={onChange}
            placeholder={emailPlaceholder}
          />
        ) : null}
      </div>
    </div>
  );
}
